export class Cart {
    async addItems(items) {
        // TODO: Use custom object.
        // TODO: Fix this type error.
        // @ts-ignore
        const { routes } = window.Shopify;
        // TODO: Use fetch-retry.
        // TODO: Do not hardcode cart route.
        const response = await fetch(routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items,
                sections: this.sectionsToRender,
            }),
        });
        const responseJson = await response.json();
        if (!response.ok) {
            return {
                success: false,
                error: responseJson.description,
            };
        }
        return {
            success: true,
            data: responseJson,
        };
    }
    async changeItem(item) {
        // TODO: Use custom object.
        // TODO: Fix this type error.
        // @ts-ignore
        const { routes } = window.Shopify;
        // TODO: Use fetch-retry.
        // TODO: Do not hardcode cart route.
        const response = await fetch(routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...item,
                sections: this.sectionsToRender,
            }),
        });
        const responseJson = await response.json();
        if (!response.ok) {
            return {
                success: false,
                error: responseJson.description,
            };
        }
        return {
            success: true,
            data: responseJson,
        };
    }
    async removeItem(id) {
        return this.changeItem({ id, quantity: 0 });
    }
    get sectionsToRender() {
        return [...document.querySelectorAll('[data-section-render-on-cart-upate]')]
            .map((element) => element.getAttribute('data-section-id'))
            .filter(Boolean);
    }
}
